import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import FontelloIcon from '@sport1/news-styleguide/FontelloIcon'
import Touchable from '@sport1/news-styleguide/Touchable'

import React, { FC } from 'react'

export const ArrowDropdown: FC<{
    setShowDropdown?: () => void
    showDropdown: boolean
    testID?: string
}> = ({ setShowDropdown, showDropdown, testID }) => (
    <Touchable onPress={setShowDropdown} testID={testID}>
        <NonFlexingContainer
            paddingX="spacing-5"
            width="44px"
            height="44px"
            centerVertical
            centerHorizontal
        >
            <FontelloIcon
                name={`${showDropdown ? 'expand_less' : 'expand_more'}`}
                fontSize={24}
                color="white"
            />
        </NonFlexingContainer>
    </Touchable>
)
